import { createContext, useContext } from 'react';

/**
 * The saved conversation a transcript shows, for cards that act on it (a
 * view's button previews its action in this thread). Null for a chat not yet
 * saved, or a surface that doesn't provide one (project chat).
 */
export const ChatThreadContext = createContext<string | null>(null);

export function useChatThreadId(): string | null {
  return useContext(ChatThreadContext);
}
